var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:none;}.aDateIcon{stroke:#92a5ef;stroke-miterlimit:10;stroke-width:2px;}.b,.cDateIcon{fill:#141416;}.b{fill-rule:evenodd;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "aDateIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 48,
    height: 48,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,18a8,8,0,1,0-8-8A8,8,0,0,0,10,18Zm0,2A10,10,0,1,0,0,10,10,10,0,0,0,10,20Z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cDateIcon",
    d: "M1,0A1,1,0,0,1,2,1V5.586L4.207,7.793A1,1,0,1,1,2.793,9.207l-2.5-2.5A1,1,0,0,1,0,6V1A1,1,0,0,1,1,0Z",
    transform: "translate(11 6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatesIcon);
export default __webpack_public_path__ + "static/media/dates-icon.f184ae4e570220bdb97ed7cc1ddb20ac.svg";
export { ForwardRef as ReactComponent };